module.exports = __webpack_public_path__ + "static/e801ded290f96d32ed7a4b5b45e93b7d.png";